"use client"

const OPEN_COOKIE_BANNER_EVENT = "astra-open-cookie-banner"

export function CookieSettingsLink() {
  const handleClick = () => {
    window.dispatchEvent(new Event(OPEN_COOKIE_BANNER_EVENT))
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="hover:text-white/60 transition-colors"
      aria-label="Gerenciar preferências de cookies"
    >
      Cookies
    </button>
  )
}
